import { HousingPayment, LoanSummary, RentalUnit } from '../types/dscr'

export const loan: LoanSummary = {
  loanNumber: '0000944',
  borrower: 'Bala Krishnan',
  propertyAddress: '418 Halsey St, Brooklyn, NY 11233',
  propertyType: '3-Unit Multi-Family — Investment',
  loanAmount: 742000,
  noteRate: 7.375,
  loanOfficer: 'Dana Whitfield',
  arriveSyncedAt: '2026-09-14T09:12:00-06:00',
}

/** Housing payment as it currently exists in Arive. Refreshing restores these values. */
export const arriveHousingPayment: HousingPayment = {
  principalAndInterest: 5124.18,
  homeownersInsurance: 318.0,
  propertyTax: 691.25,
  mortgageInsurance: 0,
  other: 145.0,
}

export const initialUnits: RentalUnit[] = [
  { id: 'unit-1', label: 'Unit 1', monthlyRent: 2650 },
  { id: 'unit-2', label: 'Unit 2', monthlyRent: 2500 },
  { id: 'unit-3', label: 'Unit 3', monthlyRent: 2275 },
]
